import { TableCell as MuiTableCell } from "@mui/material";
import { styled } from "@mui/material/styles";

export const TableCell = styled(MuiTableCell)(({ theme }) => ({
  fontSize: "14px",
  padding: theme.spacing(2),
  color: "#000",
}));

export const TableHeadCell = styled(MuiTableCell)(({ theme }) => ({
  fontSize: "12px",
  fontWeight: 700,
  padding: theme.spacing(2),
  backgroundColor: "#fafafa",
  color: "#000",
  textTransform: "uppercase",
  letterSpacing: "0.5px",
  border: "none",
}));
